import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axiosInstance from '../config/axios';

function RegisterPage({ setIsAuthenticated }) {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [shippingAddress, setShippingAddress] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      const { data } = await axiosInstance.post('/api/users/register', {
        username,
        email,
        password,
        shippingAddress,
      });
      localStorage.setItem('authToken', data.token);
      setIsAuthenticated(true);
      window.dispatchEvent(new Event('auth-updated'));
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed. Please check your details and try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <section className="auth-card wide">
        <span className="eyebrow">Start buying and selling</span>
        <h1>Create your marketplace account.</h1>
        {error && <div className="notice error">{error}</div>}
        <form onSubmit={handleRegister} className="stacked-form">
          <label>
            Username
            <input
              type="text"
              placeholder="Choose a seller name"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              maxLength="20"
              minLength="3"
              required
            />
          </label>
          <label>
            Email
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              maxLength="320"
              required
            />
          </label>
          <label>
            Password
            <input
              type="password"
              placeholder="Create a password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          <label>
            Shipping Address
            <input
              type="text"
              placeholder="Where orders should ship"
              value={shippingAddress}
              onChange={(e) => setShippingAddress(e.target.value)}
              maxLength="200"
              required
            />
          </label>
          <button type="submit" className="button button-primary" disabled={submitting}>
            {submitting ? 'Creating Account...' : 'Create Account'}
          </button>
        </form>
        <p className="auth-switch">
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </section>
    </div>
  );
}

export default RegisterPage;
